// if the component has the showCollapse variable in data, we use this from
// the parent view to cycle through the children to allow for collapseAll/expandAll
// functionality.
// NOTE: this is also in BaseListCard, so cards that use this slot don't have to implement it
// as the collapse functionality is inside the slot (but they will need to use the CollapseParent
// mixin to facilitate the call to this in BaseListCard.  Other cards that manage the collapse
// themselves need to use this
export default {
  methods: {
    forceCollapse() {
      this.showCollapse = false;
    },
    forceExpand() {
      this.showCollapse = true;
    },
  },
};
